import { render } from "./ComponentUpload.vue?vue&type=template&id=7f60a75c"
import script from "./ComponentUpload.vue?vue&type=script&lang=js"
export * from "./ComponentUpload.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__